<template>
  <v-textarea
    ref="description_input"
    class="small-textarea"
    label="Ausgeführte Arbeiten"
    :rows="descriptionRows"
    :value="value"
    :hide-details="hideDetails"
    :disabled="disabled"
    :loading="loading"
    @input="onInput"
    @keydown.13="onkeydown"
  />
</template>

<script>
export default {
  props: [
    'direction',
    'disabled',
    'hideDetails',
    'loading',
    'value',
  ],
  computed: {
    descriptionRows () {
      return 1
      return this.direction !== 'column' ? 1 : 4
    }
  },
  methods: {
    onkeydown (e) {
      if (e.key === 'Enter' && e.ctrlKey === true) {
        this.$refs.description_input.blur()
        this.$emit('keydown', e)
      }
    },
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style>
.v-textarea.small-textarea textarea {
  padding: 0;
}
</style>
